export default __webpack_public_path__ + "static/media/Teddy V.b068f349.png";